import React, { Suspense, lazy, useMemo } from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { persistStore } from 'redux-persist'

// Lazy load components to improve startup time
const ConnectedRouter = lazy(() =>
  import('connected-react-router').then(m => ({ default: m.ConnectedRouter }))
)
const Content = lazy(() => import('./Content'))

import { getRoutes, getHistory } from 'pmt-modules/routing'
import ErrorBoundary from 'pmt-ui/ErrorBoundary'
import configureRoutes from './utils/configureRoutes'

const App = ({ store }) => {
  const persistor = persistStore(store)

  return (
    <ErrorBoundary>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Suspense fallback={<div>Loading...</div>}>
            <Content>
              <ConnectedRouter history={getHistory()}>
                {configureRoutes({ routes: getRoutes() })}
              </ConnectedRouter>
            </Content>
          </Suspense>
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  )
}

App.propTypes = {
  store: PropTypes.object.isRequired,
}

export default App
